function updateDOMWithReviews(totalReviews) {
    for (const location in window.locations) {
        const locationData = JSON.parse(window.locations[location]);
        totalReviews += locationData.userRatingCount;
    }
    if (totalReviews > 0) {
        document.querySelectorAll('.accent__text.stars .rating_stars').forEach(element => {
            element.insertAdjacentHTML('afterend', `<span>${totalReviews}</span>`);
        });
        if (document.querySelector('.grp-main-hyper-link b')) {
            document.querySelector('.grp-main-hyper-link b').innerHTML = `${totalReviews} Reviews`;
        }
    }
}
window.onload = updateDOMWithReviews(0);